import { EmailNotificationGroupTitle } from '#types';
import { GraphQLFormattedError } from 'graphql';
import rpcShared from '@rockpapercoin/rpc-shared';

type ValidationDictionary = Partial<
	Record<
		EmailNotificationGroupTitle,
		{
			errorText?: string;
			emailAddresses: string[];
		}
	>
>;

const validationErrorRegExp =
	/Validation Error: (.+) cannot be added to the (.+) email notification group/;

export const notificationGroupGraphqlErrorFiltering = (
	errors?: readonly GraphQLFormattedError[] | undefined,
	includeMessageAsErrorText?: true
) => {
	const validation: ValidationDictionary | undefined = errors?.reduce(
		( acc, error ) => {
			const matches = error.message.match( validationErrorRegExp );
			if ( matches ) {
				const emails = matches[ 1 ].split( ', ' );
				const groupTitleRaw = matches[ 2 ];
				const recordEntries = Object.entries(
					rpcShared.emailNotificationGroups.UserFriendlyGroupNames
				) as [EmailNotificationGroupTitle, string][];
				const groupTitle = recordEntries.find(
					( pair ) => pair[ 1 ] === groupTitleRaw
				)?.[ 0 ];
				if ( groupTitle ) {
					return {
						...acc,
						[ groupTitle ]: {
							emailAddresses: emails,
							...( includeMessageAsErrorText
								? { errorText: error.message.replace( 'Validation Error: ', '' ) }
								: {} ),
						},
					};
				}
			}
			return acc;
		},
		{}
	);
	return {
		validation,
		remainingErrors: errors?.filter(
			( error ) => !error.message.match( validationErrorRegExp )
		),
	};
};
